var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "download_svg__svg-icon",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M29.987 36.666 19.159 25.84l-2.836 2.837L32 44.352l15.677-15.676-2.836-2.837-10.828 10.827V5.892h-4.026zM6.258 57.742h51.484V43.895h-4.026v9.821H10.284v-9.82H6.258z",
    clipRule: "evenodd"
  })));
};
export { SvgDownload as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjQgNjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTI5Ljk4NyAzNi42NjYzTDE5LjE1ODkgMjUuODM4N0wxNi4zMjM0IDI4LjY3NjFMMzIgNDQuMzUyNEw0Ny42NzY2IDI4LjY3NjFMNDQuODQxMSAyNS44Mzg3TDM0LjAxMyAzNi42NjYzVjUuODkyMDlIMjkuOTg3VjM2LjY2NjNaTTYuMjU4IDU3Ljc0MjFINTcuNzQyVjQzLjg5NTFINTMuNzE2VjUzLjcxNjFIMTAuMjg0VjQzLjg5NTFINi4yNThWNTcuNzQyMVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjwvc3ZnPg==";